<template>
    <div class="bank-info">
        <el-form
            ref="cardForm"
            :model="cardForm"
            :rules="rules"
            label-width="100px"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="证件类型:" :required="true" prop="certificatetype">
                <el-input v-model.trim="cardForm.certificatetype" disabled />
            </el-form-item>
            <el-form-item label="证件号码:" :required="true" prop="certificateno">
                <el-input v-model.trim="cardForm.certificateno" disabled />
            </el-form-item>
            <el-form-item label="真实姓名:" :required="true" prop="custname">
                <el-input v-model.trim="cardForm.custname" disabled />
            </el-form-item>
            <el-form-item label="选择账户:" :required="true" prop="account">
                <el-select
                    v-model="cardForm.account"
                    placeholder="请选择银行账户"
                    style="width: 440px"
                    v-on:change="selectAccount"
                >
                    <el-option
                        v-for="item in cardList"
                        :key="item.index"
                        :label="item.account"
                        :value="item.index"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="银行卡号:" :required="true" prop="depositcard">
                <el-input
                    v-model.trim="cardForm.depositcard"
                    placeholder="选择银行账户后自动带出"
                    disabled
                />
            </el-form-item>
            <el-form-item label="手机号码:" :required="true" prop="mobileno">
                <el-input
                    v-model.trim="cardForm.mobileno"
                    placeholder="请输入手机号码"
                    :maxlength="11"
                />
            </el-form-item>
            <div class="btn-contain">
                <el-button class="cancel-btn" v-on:click="checkDialogClose">取消</el-button>
                <el-button class="confirm-btn" v-on:click="submitInfo">确定</el-button>
            </div>
            <div class="warn-tip">
                <div class="tip-title">温馨提示</div>
                <div class="tip-text">
                    1、为了保证您的账户安全，由于您不能通过原手机号码进行身份验证，系统将通过银行卡身份认证流程帮您完成手机号码修改。
                </div>
                <div class="tip-text">
                    2、如果您的支付渠道未在选择账户列表中，将无法自助修改手机号码，请致电客服
                    <span>{{ $cache.getCompanyInfoParam("10101009") }}</span>
                    。
                </div>
            </div>
        </el-form>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";

export default {
    name: "CheckAcct",
    components: {},
    mixins: [mixin],
    data() {
        return {
            cardForm: {
                certificatetype: "",
                certificateno: "",
                custname: "",
                mobileno: "",
                account: "",
                depositcard: ""
            },
            cardList: [], // 银行卡列表
            selectCard: {}, // 选中的银行卡
            rules: {
                account: [
                    {
                        required: true,
                        message: "请选择银行账户",
                        trigger: "blur"
                    }
                ],
                depositcard: [
                    {
                        required: true,
                        message: "请选择银行卡号",
                        trigger: "blur"
                    }
                ],
                mobileno: [
                    { required: true, message: "请输入手机号码", trigger: ["blur", "change"] },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ]
            }
        };
    },
    mounted() {
        const userInfo = this.$cache.getUser();
        this.cardForm.certificatetype = this.$cache.getDict("130007", userInfo.certificatetype);
        this.cardForm.certificateno = userInfo.certificateno;
        this.cardForm.custname = userInfo.custname;
        this.getBankInfo();
    },
    methods: {
        // 查询已绑定银行卡
        async getBankInfo() {
            const res = await userApi.getMyBankCards();
            if (res.data) {
                const array = res.data.data ? res.data.data : [];
                // 鉴权需要过滤掉汇款卡和柜台渠道
                this.cardList = array.filter((item) => {
                    return (
                        item.paycenterid != "0001" &&
                        item.paycenterid != "1000" &&
                        (item.channeltype || "") !== "1"
                    ); // 0 普通渠道 1 三方渠道 ;
                });
                this.cardList.forEach((card, index) => {
                    card.index = index;
                    card.account =
                        this.$cache.getDict("110080", card.bankcode) +
                        "(" +
                        card.depositcard.substr(-7, 7) +
                        ")";
                });
            }
        },
        // 选择银行账户
        selectAccount(value) {
            this.selectCard = this.cardList[value];
            this.cardForm.depositcard = this.selectCard.depositcard;
        },
        // 取消修改
        checkDialogClose() {
            this.cardForm = {};
            this.$emit("check-dialog-close");
        },
        // 确定修改手机号码
        submitInfo() {
            const _this = this;
            this.$refs["cardForm"].validate((valid) => {
                if (valid) {
                    _this.checkBankCard();
                }
            });
        },
        // 校验银行卡
        checkBankCard() {
            const params = {
                bankcode: this.selectCard.bankcode,
                paychannel: this.selectCard.paycenterid,
                bankcardid: this.selectCard.bankcardid,
                depositcard: this.selectCard.depositcard,
                mobileno: this.cardForm.mobileno,
                verifytype: "1"
            };
            this.$emit("check-card-apply", params);
        }
    }
};
</script>

<style lang="scss">
.bank-info {
    padding: 30px 40px 10px;
    .el-form-item {
        margin-bottom: 23px !important;
    }
    .el-form-item__label {
        color: #333333;
    }
    .el-form-item__error {
        position: absolute;
        top: 100%;
        left: 0;
    }
    .el-form-item__error--inline {
        position: absolute;
        top: 100%;
        left: 0;
    }
    .btn-contain {
        text-align: center;
        .cancel-btn {
            padding: 10px 0;
            width: 180px;
            border-radius: 2px;
            background: #e4e4e4;
            font-size: 16px;
            font-weight: 500;
            color: #666666;
            border: 1px solid #e4e4e4;
            cursor: pointer;
        }
        .confirm-btn {
            margin-left: 40px;
            padding: 10px 0;
            width: 180px;
            border-radius: 2px;
            background: #e60012;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            border: 1px solid #e60012;
            cursor: pointer;
        }
    }
    .warn-tip {
        padding: 30px 30px 0 0;
        .tip-title {
            font-size: 16px;
            font-weight: normal;
            color: #666666;
            line-height: normal;
            margin-bottom: 10px;
        }
        .tip-text {
            font-size: 14px;
            line-height: 26px;
            font-weight: normal;
            color: #333333;
            line-height: normal;
            margin-bottom: 5px;
        }
    }
}
</style>
